import * as React from 'react';
import {styled} from '../../utils';
import Avatar, {AvatarProps} from '../Avatar';
import {AvatarStackProps} from './types';

const Root = styled('div')({
  display: 'inline-block'
});

const List = styled('ul')({
  marginLeft: 8,
  listStyle: 'none'
});

const ListItem = styled('li')({
  display: 'inline-block',
  marginRight: -8
});

export default class AvatarStack extends React.Component<AvatarStackProps, {}> {
  public render() {
    const {children, maxLength, small, large, larger, circle, ...restProps} = this.props;

    const overrideAvatarProps = {small, large, larger, circle};

    const numberOfItems = React.Children.count(children);

    const numberOfExcessiveItems = numberOfItems - maxLength;

    const displayItems = React.Children.map(children, (child, index) => {
      if (index < maxLength && React.isValidElement(child) && child.type === Avatar) {
        const itemProps: AvatarProps = {
          ...child.props,
          ...overrideAvatarProps
        };
        return (
          <ListItem>
            <Avatar {...itemProps} />
          </ListItem>
        );
      }
      return null;
    });

    const moreItems =
      numberOfExcessiveItems > 0 ? (
        <ListItem>
          <Avatar {...overrideAvatarProps}>+{numberOfExcessiveItems}</Avatar>
        </ListItem>
      ) : null;

    return (
      <Root {...restProps}>
        <List>
          {displayItems}
          {moreItems}
        </List>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AvatarStack/AvatarStack.tsx